import AccountDetailsCheckboxInput from './AccountDetailsCheckboxInput'

export default AccountDetailsCheckboxInput


// WEBPACK FOOTER //
// ./src/components/AccountDetailsCheckboxInput/index.js